import CollageSdk from '@wix/thunderbolt-elements/src/components/Collage/corvid/Collage.corvid';


const Collage = {
  sdk: CollageSdk
};


export const components = {
  ['Collage']: Collage
};

